import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { DndProvider } from 'react-dnd-multi-backend';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import { getUuid } from 'ziphy-web-shared/basic/helpers';
import { $windowSize } from 'ziphy-web-shared/basic/utils';
import DragAndDropHelpers from './DragAndDrop.helpers';
import DragAndDropItem from './DragAndDropItem';
var clearMemo = DragAndDropHelpers.clear;
const DragAndDrop = ({ selectedItems, unsupportedItems, removeItem, moveSelected, selectedCount, focusedItemIndex, isSearchableByAll, isDisabled, allowEmpty, }) => {
    const dropAreaId = useMemo(() => getUuid(), []);
    useEffect(() => {
        clearMemo();
    }, [selectedItems, $windowSize.width]);
    return (_jsx(DndProvider, Object.assign({ options: HTML5toTouch }, { children: selectedItems.map((item, index) => (_jsx(DragAndDropItem, { index: index, item: item, dropAreaId: dropAreaId, onRemove: (e) => removeItem(e, item), onMove: moveSelected, hasPopup: isSearchableByAll, hasClose: selectedCount > 1 || (selectedCount === 1 && allowEmpty), isUnsupported: unsupportedItems === null || unsupportedItems === void 0 ? void 0 : unsupportedItems.includes(item.id), isFocused: focusedItemIndex === index, isDisabled: isDisabled }, item.id))) })));
};
export default observer(DragAndDrop);
